import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'LIST_CLIENT',
  title: 'Pourquoi je ne vois pas mes clients dans ma liste de clients ? ',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Avez-vous vérifié dans l’onglet « invitations envoyées » ?'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_LIST_CLIENT/FR_LIST_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Ici se trouve les invitations envoyées, en attente d’acceptation de votre client.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'S’ils n’ont pas répondu à votre demande, vous avez la possibilité de les relancer au bout de 15 jours en cliquant sur « Inviter à nouveau ».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_LIST_CLIENT/FR_LIST_CLIENT_2.png`
  }]
};
